"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";

import { useAuth } from "@/shared/auth/hooks";
import { CHANNEL_TALK_PLUGIN_KEY } from "@/config/env";

if (typeof window !== "undefined" && CHANNEL_TALK_PLUGIN_KEY) {
  ChannelService.loadScript();
}

export function ChannelTalkProvider() {
  const pathname = usePathname();
  const { user, isLoading } = useAuth();

  const isAdminPath = pathname?.startsWith("/admin") ?? false;

  useEffect(() => {
    if (!CHANNEL_TALK_PLUGIN_KEY) return;
    // admin 경로는 AdminChannelTalk 가 브랜드 아이덴티티로 부팅한다.
    if (isAdminPath) return;
    if (isLoading) return;

    const common = {
      pluginKey: CHANNEL_TALK_PLUGIN_KEY,
      hideChannelButtonOnBoot: true,
    };

    if (user) {
      ChannelService.boot({
        ...common,
        memberId: user.id,
        profile: {
          name: user.businessName || null,
          email: user.email || null,
        },
      });
    } else {
      ChannelService.boot(common);
    }
  }, [isAdminPath, isLoading, user]);

  return null;
}
